// user.activation_data.spotlights dismissal keys shared across features and debug tooling.

export const MEETINGS_ONBOARDING_TOUR_SPOTLIGHT_KEY = 'meetings_page_onboarding_tour_dismissed'

export const BRAND_REFRESH_NAV_TOUR_SPOTLIGHT_KEY = 'brand_refresh_nav_tour_dismissed'

export const SCHEDULING_PAGE_TOUR_SPOTLIGHT_KEY = 'scheduling_page_onboarding_tour_dismissed'

const NOTETAKER_NAV_SPOTLIGHT_KEY = 'notetaker_nav_spotlight_dismissed'

const MEETING_RECAP_ACTION_ITEMS_REMIND_SPOTLIGHT_KEY = 'meeting_recap_action_items_remind_spotlight_dismissed'

const CRM_ADD_CONTACT_SPOTLIGHT_KEY = 'crm_add_contact_spotlight_dismissed'

/** Explicit false values for debug reset — server merge keeps stale keys if omitted. */
export const CLEARED_SPOTLIGHTS_STATE = {
  [MEETINGS_ONBOARDING_TOUR_SPOTLIGHT_KEY]: false,
  [BRAND_REFRESH_NAV_TOUR_SPOTLIGHT_KEY]: false,
  [SCHEDULING_PAGE_TOUR_SPOTLIGHT_KEY]: false,
  [NOTETAKER_NAV_SPOTLIGHT_KEY]: false,
  [MEETING_RECAP_ACTION_ITEMS_REMIND_SPOTLIGHT_KEY]: false,
  [CRM_ADD_CONTACT_SPOTLIGHT_KEY]: false,
}
